export default __webpack_public_path__ + "static/media/3.a337c1c5.png";